import { useAuth } from "@/_core/hooks/useAuth";
import {
  HRS_CONFIGURATOR_PATH,
  isHrsTesterEmail,
} from "@shared/hrsTesterAccess";
import { useEffect } from "react";
import { useLocation } from "wouter";

export default function HrsTesterRouteGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user, loading } = useAuth();
  const [location, setLocation] = useLocation();

  useEffect(() => {
    if (loading || !isHrsTesterEmail(user?.email)) return;
    if (location !== HRS_CONFIGURATOR_PATH) setLocation(HRS_CONFIGURATOR_PATH);
  }, [loading, location, setLocation, user?.email]);

  return <>{children}</>;
}
